var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetsoLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156.9 73.1",
    style: {
      enableBackground: "new 0 0 156.9 73.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.3,27.9c-7.1,0-10.9,5.3-10.9,12.2c0,6.9,3.8,12.3,10.9,12.3c7.1,0,10.9-5.3,10.9-12.3 C136.2,33.1,132.3,27.9,125.3,27.9 M125.3,47.5c-3.7,0-5.7-2.7-5.7-7.5c0-4.2,1.5-7.4,5.7-7.4c3.7,0,5.7,2.5,5.7,7.4 C131,45,129,47.5,125.3,47.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,44.6V32.9h6.7v-4.6h-6.7v-7.5h-5.1v24.7c0,4.2,2.6,6.8,6.8,6.8c2.4,0,4.4-0.6,6-1.4l-1.3-4.3 C88.3,47.8,84.3,48.3,84.4,44.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6,27.9c-6.4,0-10.4,5.8-10.4,12.1c0,6.8,3.8,12.3,10.9,12.3c3.2,0,6.6-1.2,9-3.3l-2.4-3.8c-1.7,1.5-3.7,2.5-6.4,2.5 c-3.3,0-5.7-2.6-6-5.4h15.6c0-0.8,0.1-1.6,0.1-2.4C76,32.2,72.2,27.9,65.6,27.9 M60.4,38c0.3-4,3-5.7,5.2-5.7c3.2,0,5.1,2,5.2,5.6 l0,0.1H60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6,37.9l-3.7-0.7c-1.8-0.4-2.6-1.1-2.6-2.4c0-2,2.3-2.7,4.3-2.7c1.9,0,3.9,0.5,5.7,1.7l2.4-3.8 c-2.1-1.3-4.9-2.2-8.2-2.2c-4.9,0-9.2,2.4-9.2,7.4c0,3.7,2.1,5.8,6.4,6.7l3.7,0.7c1.8,0.4,2.5,1.2,2.5,2.6c0,1.6-1.3,2.7-3.8,2.7 c-1.8,0-4-0.5-6.4-2.7L94,48.8c2.1,2.3,5.5,3.5,9.1,3.5c4.9,0,9-2.4,9-7.4C112,40.8,109.7,38.7,105.6,37.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.2,42.1 26.2,20.8 20.8,20.8 20.8,52 26,52 26,31.4 33.9,48.2 38.5,48.2 46.4,31.4 46.4,52 51.7,52 51.7,20.8  46.3,20.8  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetsoLogoBlack);
export default __webpack_public_path__ + "static/media/metso_logo_black.c584544f762a68548639d1ab4a85a1a5.svg";
export { ForwardRef as ReactComponent };